import { OfflineState } from "../../design/shell";
import { TRAPillButton } from "../../design/visual";
import s from "./appLoadingShell.module.css";

/**
 * Full-viewport offline recovery — used when auth bootstrap cannot finish offline.
 * Preserves brand frame; never leaves a blank white root.
 */
export default function OfflineRecoveryScreen({
  title = "You’re offline",
  description = "Reconnect to load TheRallyAlly. Cached pages stay available when the app is already open.",
}) {
  return (
    <div
      className={`tra-player-profile tra-visual-v2 ss-player-route ${s.shell}`}
      data-testid="offline-recovery-screen"
      role="status"
    >
      <div className={s.frame}>
        <OfflineState
          title={title}
          description={description}
          action={
            <TRAPillButton
              type="button"
              variant="cta"
              onClick={() => {
                if (typeof window !== "undefined") window.location.reload();
              }}
            >
              Try again
            </TRAPillButton>
          }
        />
      </div>
    </div>
  );
}
